/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_Stock_Warehouse_SortingInputs */

const vi_tea_grade_stock_warehouse_sorting = /** @type {(inputs: Tea_Grade_Stock_Warehouse_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho phân loại`)
};

/**

* @param {Tea_Grade_Stock_Warehouse_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_stock_warehouse_sorting = /** @type {((inputs?: Tea_Grade_Stock_Warehouse_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Stock_Warehouse_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_stock_warehouse_sorting(inputs)
});